var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MessageList',{attrs:{"messages":_vm.messages,"approvals":_vm.approvals,"loading-message":_vm.loadingMessage}}),_c('MessageCompose',{attrs:{"sending-message":_vm.sendingMessage},on:{"compose":_vm.sendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }